/**
 * Company Research translations
 * Company research page UI text
 */

import { LANGUAGES } from '../config';

export const companyResearchTranslations = {
  [LANGUAGES.EN]: {
    title: 'Company Research',
    uploadStep: 'Enter Company Information',
    reviewStep: 'Review Research',
    enterDetailsStep: 'Enter Details',
    reviewResearchStep: 'Review Research',
    currentVersion: 'CURRENT VERSION',
    versionHistory: 'VERSION HISTORY',
    researchResults: 'Research Results',
    companyName: 'Company Name',
    enterCompany: 'Enter company name',
    research: 'Research',
    sections: 'Sections',
    overview: 'Overview',
    culture: 'Culture',
    values: 'Values',
    competitors: 'Competitors',
    opportunities: 'Opportunities',
    challenges: 'Challenges',
    noResearch: 'No research data available',
    savedSuccessfully: 'Company research saved successfully!',
    analysisFailed: 'Company analysis failed',
    processing: 'Researching company...',
    dragAndDrop: 'Drag and drop company files here, or click to select file',
    uploadCompanyFiles: 'Upload company information files',
    pasteCompanyText: 'Or paste company information',
    enterCompanyDescription: 'Company Description (optional)',
    additionalNotes: 'Additional Notes',
    researchHistory: 'Research History',
    lastResearched: 'Last researched on',
    updateResearch: 'Update Research',
    deleteResearch: 'Delete Research',
    confirmDelete: 'Are you sure you want to delete this research?',
    deleteSuccessful: 'Research deleted successfully',
    deleteFailed: 'Failed to delete research',
    editSection: 'Edit Section: {{name}}',
    preview: 'Preview',
    noDataToDisplay: 'No company research data to display'
  },
  [LANGUAGES.FR]: {
    title: 'Recherche d\'entreprise',
    uploadStep: 'Entrer les informations de l\'entreprise',
    reviewStep: 'Réviser la recherche',
    enterDetailsStep: 'Entrer les détails',
    reviewResearchStep: 'Réviser la recherche',
    currentVersion: 'VERSION ACTUELLE',
    versionHistory: 'HISTORIQUE DES VERSIONS',
    researchResults: 'Résultats de recherche',
    companyName: 'Nom de l\'entreprise',
    enterCompany: 'Entrer le nom de l\'entreprise',
    research: 'Recherche',
    sections: 'Sections',
    overview: 'Aperçu',
    culture: 'Culture',
    values: 'Valeurs',
    competitors: 'Concurrents',
    opportunities: 'Opportunités',
    challenges: 'Défis',
    noResearch: 'Aucune donnée de recherche disponible',
    savedSuccessfully: 'Recherche d\'entreprise enregistrée avec succès!',
    analysisFailed: 'L\'analyse de l\'entreprise a échoué',
    processing: 'Recherche de l\'entreprise...',
    dragAndDrop: 'Glissez et déposez les fichiers d\'entreprise ici, ou cliquez pour sélectionner un fichier',
    uploadCompanyFiles: 'Télécharger des fichiers d\'information sur l\'entreprise',
    pasteCompanyText: 'Ou coller les informations de l\'entreprise',
    enterCompanyDescription: 'Description de l\'entreprise (optionnel)',
    additionalNotes: 'Notes supplémentaires',
    researchHistory: 'Historique de recherche',
    lastResearched: 'Dernière recherche le',
    updateResearch: 'Mettre à jour la recherche',
    deleteResearch: 'Supprimer la recherche',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette recherche?',
    deleteSuccessful: 'Recherche supprimée avec succès',
    deleteFailed: 'Échec de la suppression de la recherche',
    editSection: 'Modifier la section: {{name}}',
    preview: 'Aperçu',
    noDataToDisplay: 'Aucune donnée de recherche d\'entreprise à afficher'
  }
};
